import { render, staticRenderFns } from "./AnalysisIndustry.vue?vue&type=template&id=38aa0492&"
import script from "./AnalysisIndustry.vue?vue&type=script&lang=js&"
export * from "./AnalysisIndustry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports